<template>
  <div class="header" >
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'primary',
        description: 'Header background type'
      }
    }
  }
</script>
<style>
.header {
  background: linear-gradient(90deg, #E23255 0%, #9A2F2F 100%);
  position: absolute;
  right: 0px;
  top: 0px;
  height: 200px;
  width: 100vw;
}
</style>
